import { render } from "./DesctriptionComponent.vue?vue&type=template&id=6660cf43"
import script from "./DesctriptionComponent.vue?vue&type=script&lang=js"
export * from "./DesctriptionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__